<div class="main-wrapper">

    <!-- partial:sidebar -->
    <app-sidebar></app-sidebar>
    <!-- partial -->
    <change-password-popup></change-password-popup>
    <terms-update-popup></terms-update-popup>
    <div class="page-wrapper">

        <!-- partial:navbar -->
        <app-navbar *ngIf="selectedCompany?.deletedDate != null" ></app-navbar>
        <!-- partial -->

        <div class="page-content">
            <!-- Spinner for lazyload modules -->
            <div *ngIf="isLoading" class="spinner-wrapper">
                <div class="spinner">Loading...</div>
            </div>
            <!-- [style]="isLoading ? 'display: none': ''" -->
            <div contentAnimate *ngIf="!isLoading">
                <!-- <div contentAnimate [style]="isLoading ? 'display: none': ''" > -->
                <router-outlet></router-outlet>
            </div>
        </div>

        <!-- partial:footer -->
        <app-footer></app-footer>
        <!-- partial -->

    </div>

    <app-client-feedback></app-client-feedback>

    
</div>